import { render } from "./DashboardVehicles.vue?vue&type=template&id=d488a168&scoped=true"
import script from "./DashboardVehicles.vue?vue&type=script&lang=js"
export * from "./DashboardVehicles.vue?vue&type=script&lang=js"

import "./DashboardVehicles.vue?vue&type=style&index=0&id=d488a168&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d488a168"]])

export default __exports__